/* Announcement marquee: clones a copy up to at least the bar width so the two-copy translateX(-50%)
   loop stays seamless at any screen width / message count (a short copy otherwise gaps then jump-resets). */
if (!customElements.get('announcement-marquee')) {
  customElements.define(
    'announcement-marquee',
    class extends HTMLElement {
      constructor() {
        super();
        this.fill = this.fill.bind(this);
      }

      connectedCallback() {
        this.copies = this.querySelectorAll('.announcement-marquee__copy');
        if (this.copies.length < 2) return;
        if (!this.originals) {
          this.originals = Array.from(this.copies[0].children).map((node) => node.cloneNode(true));
        }
        this.fill();
        if (!this.observer && 'ResizeObserver' in window) {
          this.observer = new window.ResizeObserver(this.fill);
          this.observer.observe(this);
        }
      }

      fill() {
        if (!this.copies || this.copies.length < 2) return;
        const first = this.copies[0];
        const second = this.copies[1];
        first.replaceChildren(...this.originals.map((node) => node.cloneNode(true)));
        let guard = 0;
        let previousWidth = 0;
        while (first.scrollWidth < this.offsetWidth && guard < 200) {
          const fragment = document.createDocumentFragment();
          this.originals.forEach((node) => fragment.appendChild(node.cloneNode(true)));
          first.appendChild(fragment);
          // If an extra copy didn't widen the track, the content can't fill the bar; stop rather than spin.
          if (first.scrollWidth <= previousWidth) break;
          previousWidth = first.scrollWidth;
          guard += 1;
        }
        second.replaceChildren(...Array.from(first.children).map((node) => node.cloneNode(true)));
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }
    }
  );
}
